import { Note } from "./note.model";
import { LoginModule } from "../login/login.module";

export class Adjudication {
  adjudicationId: number;
  patientId: string;
  mactelDiagnosis?: string;
  subStudy?: string;
  gradingEligible?: boolean;
  blrImagesAvailable?: boolean;
  blrPattern?: boolean;
  blrEye?: string;
  reviewer?: string;
  notes: Note[];
  familyMember?: string;
}

export enum MactelDiagnosis {
  yes = "yes",
  no = "no",
  cannotbedetermined = "cannot be determined",
  certification = "certification",
}

export enum BlrEyes {
  OD = "OD",
  OS = "OS",
  OU = "OU",
}



// WEBPACK FOOTER //
// ./src/app/models/adjudication.model.ts